export default __webpack_public_path__ + "static/media/smartmockups_kl7j7y1k.e70c2acd.jpg";